
export default function CTASection() {
  return (
    <section 
      className="py-20 bg-slate-900 relative"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/561e3ecb179ba2e67dd3ec248b738584.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-slate-900/80"></div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 uppercase">
          Ready to Become <span className="text-orange-400">Debt-Free?</span>
        </h2>
        
        <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
          Schedule your free consultation today<br />
          <span className="text-lg text-gray-300">No obligation, no upfront fees</span>
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <a 
            href="tel:1-800-DEBT-FREE"
            className="bg-slate-900 hover:bg-slate-800 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 flex items-center space-x-4 whitespace-nowrap"
          >
            <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center">
              <i className="fas fa-phone text-white text-sm"></i>
            </div>
            <span>CALL NOW FOR FREE CONSULTATION</span>
            <i className="fas fa-arrow-right"></i>
          </a>
          
          <span className="text-gray-300 text-lg">OR</span>
          
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="border-2 border-orange-500 text-orange-400 hover:bg-orange-500 hover:text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap"
          >
            Start Online Chat
          </button>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
          <div className="text-center">
            <div className="text-3xl font-bold text-orange-400">16+</div>
            <div className="text-white">Years Experience</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-orange-400">$500M+</div>
            <div className="text-white">Debt Settled</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-orange-400">A+</div>
            <div className="text-white">BBB Rating</div>
          </div>
        </div>
      </div>
    </section>
  );
}
